<template>
  <div class="on-job-online-btn" v-if="isShowBtn">
    <base-popover-with-close
      position="top-right"
      :content="`若没有在职证明，可在线生成打印签字后扫描录入`"
      width="220px"
      :hide-popover="hidePopover"
    >
      <div class="online-btn" @click="gotoOnJob">
        <img class="icon" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/on-job/icon-btn.png" alt="">
        <div class="text">在线生成</div>
      </div>
    </base-popover-with-close>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import BasePopoverWithClose from '../../../components/common/popover/base-popover-with-close.vue';
import materialConstants from '../../../constants/material-constants';
import orderService from '../../../services/order-service';

export default {
  components: {
    BasePopoverWithClose,
  },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    applicant: {
      type: Object,
      default() {
        return {};
      },
    },
    material: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    isShowBtn() {
      // 是否是在职证明
      if (this.material.relation_type_id !== materialConstants.RELATION_TYPE_ID.on_job_1) return false;
      // 是否存在可以编辑的upload, 兼容未上传的情况
      const hasAllowUpload = this.material.upload && this.material.upload.length ? 
        this.material.upload.some(item => orderService.isAllowUpload(this.order, this.applicant, item))
        : orderService.isAllowUpload(this.order, this.applicant);
      return hasAllowUpload;
    },
    hidePopover() {
      if (!this.material.upload || !this.material.upload[0]) return false;
      return Boolean(
        [
          materialConstants.ELEC_STATUS.qualified_0,
          materialConstants.ELEC_STATUS.waittingForVerified_2,
          materialConstants.ELEC_STATUS.unqualified_3,
        ].indexOf(this.material.upload[0].elec_status) > -1 ||
        this.material.upload[0].url,
      );
    },
  },
  created() {},
  methods: {
    gotoOnJob() {
      sensorsdata.track('On_the_job_order', {});
      const { href } = this.$router.resolve({ name: 'OnJobList' });
      window.open(href, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>

.on-job-online-btn{
  .online-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .icon{
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    .text{
      color: #599FFF;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/component/on-job-online-btn.vue